<template>
  <DatatableReportV3
    id="members-table"
    title="By Program"
    download-url="/reports/members"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import TagList from "@/Tags/TagList.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        order: [[1, "asc"]],
        columns: [
          { data: "customer", aggregateTitle: "Distinct Customers" },
          {
            data: "membership_status",
            title: "Member Status",
            filterName: "membership_status",
            searchable: false
          },
          { data: "program", filterName: "program", searchable: false },
          {
            data: "payment_method_on_file",
            title: "Payment Method on File",
            filterName: "payment_method_on_file",
            orderable: false,
            searchable: false
          },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          { data: "tags", title: "Tags", orderable: false, searchable: false },
          { data: "location_name", title: "Location Name" },
          { data: "address", title: "Billing Address" },
          { data: "zipcode", title: "Zip Code" },
          {
            data: "renewal_type",
            title: "Renewal Type",
            filterName: "renewal_type",
            orderable: false,
            searchable: false
          },
          { data: "since", filterName: "starts_on", searchable: false },
          { data: "renews_at", title: "Next Billing Date", searchable: false },
          { data: "ends_on", title: "Ends On", searchable: false }
        ],
        vueComponents: [
          {
            rootId: "tag-list-vue",
            component: TagList
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Members" });
  }
};
</script>

<style lang="scss" scoped></style>
